
import { createAction, props } from '@ngrx/store';
import { ProductCar } from '../../models/productCar.model';

export const addToCar = createAction('[Adding To Car] Add',
  props<{ product: ProductCar }>()
);

export const modifyProduct = createAction('[Modify Product] Modify',
  props<{ id: number, count: number }>()
);

export const modifyTokenProduct = createAction('[Modify TokenProduct] Modify',
  props<{ id: number, token: string }>()
);

export const removeToCar = createAction('[Removing To Car] Decrement',
  props<{ id: number }>()
);
